import { render, staticRenderFns } from "./myPrescribeRegModal.vue?vue&type=template&id=2d346a70"
import script from "./myPrescribeRegModal.vue?vue&type=script&lang=js"
export * from "./myPrescribeRegModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports